import FooterOne from '../Footer/FooterOne';
import Header from '../Header/HeaderOne';
import { pageTitle } from '../PageTitle';
import React, { useEffect, useMemo, useState } from 'react';
import Preloader from '../Preloader/Preloader';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import useFemaleRatingStore from '../../store/femaleRatingStore';
import ReactPaginate from 'react-paginate';
import '../../assets/sass/Pagination.css'


const FemalePage = () => {
    pageTitle("FEMALE RATING")
    const [viewRating, setViewRating] = useState([]);
    const [firstValues, setFirstValues] = useState({ kills: 0, kd: 0, tournaments: 0 });
    const [filterState, setFilterState] = useState('kills');
    const { female, setFemale, isLoading, setLoading } = useFemaleRatingStore();
    const [searchInputState, setSearchInputState] = useState('');


    const fetchData = async () => {
        setLoading(true);
        try {
            const querySnapshot = await getDocs(collection(db, 'femaleRating'));
            const data = querySnapshot.docs.map(doc => doc.data());
            setFemale(data);
            localStorage.setItem('femaleLastFetchTime', Date.now().toString()); 
            localStorage.setItem('female', JSON.stringify(data));
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
        } finally {
            setLoading(false); 
        }
    };

    const shouldFetchData = () => {
        const lastFetchTime = localStorage.getItem('femaleLastFetchTime');
        const currentTime = Date.now();
        const twelveHoursInMillis = 12 * 60 * 60 * 1000; 

        return !lastFetchTime || (currentTime - parseInt(lastFetchTime)) > twelveHoursInMillis;
    };

    useEffect(() => {
        const storedfemale = localStorage.getItem('female');
        if (shouldFetchData()) {
            fetchData();
        } else if (storedfemale) {
            setFemale(JSON.parse(storedfemale));
            setLoading(false)
        }
    }, []); 

    useEffect(() => {
        if (female.length > 0) {
            const calculatedPlayers = female.map(player => {
                if (!player.tournament) return player;

                const totalKills = player.tournament.reduce((sum, el) => sum + el.kills, 0);
                const totalKd = player.tournament.reduce((sum, el) => sum + el.kd, 0);
                const kdLen = player.tournament.length;

                return {
                    ...player,
                    kills: totalKills,
                    kd: totalKd,
                    kdLen: kdLen,
                };
            }).filter(player => player.tournament);

            setViewRating(calculatedPlayers);
            const maxKills = Math.max(...calculatedPlayers.map(player => player.kills), 0);
            const maxKd = Math.max(...calculatedPlayers.map(player => player.kd / player.kdLen || 0), 0);
            const maxTournaments = Math.max(...calculatedPlayers.map(player => player.tournament.length), 0);
            setFirstValues({ kills: maxKills, kd: maxKd, tournaments: maxTournaments });
        }
    }, [female]);

    const filteredRating = useMemo(() => {
        return viewRating.filter(el => el.playerName.toLowerCase().includes(searchInputState.trim().toLowerCase()));
    }, [viewRating, searchInputState]);

    const sortedfemale = useMemo(() => {
        return [...filteredRating].sort((a, b) => {
            if (filterState === 'kills') {
                return b.kills - a.kills;
            } else if (filterState === 'tournaments') {
                return b.tournament.length - a.tournament.length;
            } else {
                return (b.kd / b.kdLen) - (a.kd / a.kdLen);
            }
        });
    }, [filteredRating, filterState]);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9;

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        window.scrollTo(0, 0)
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = sortedfemale.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(sortedfemale.length / itemsPerPage);

    return <>
        {
            !isLoading ? <>
                <Header></Header>
                    <div className="services__page section-padding">
                        <div className="container">
                            <div className="row mb-30">
                                <div className="col-xl-6 col-lg-8">
                                    <div style={{marginBottom: '20px'}} className="services__page-title lg-t-center">
                                        <span className="subtitle">rating</span>
                                        <h2>Female rating</h2>
                                    </div>
                                    <div className="services__page-title lg-t-center">
                                        <h2>Selected filter - {filterState}</h2>
                                    </div>
                                    <div className="services__page-title lg-t-center">
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('kills')}>Kills</button>
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('KD')}>KD</button>
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('tournaments')}>Tournaments</button>
                                    </div>
                                    <div style={{marginTop: '10px'}} >
                                        <p>Search</p>
                                        <input placeholder='NickName' style={{backgroundColor: 'transparent'}} type="text" value={searchInputState} onChange={e => setSearchInputState(e.target.value)} />
                                    </div>
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'..'}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={2}
                                        onPageChange={handlePageClick}
                                        containerClassName={'pagination-tme'}
                                        activeClassName={'active'}
                                        disabledClassName={'disabled'}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                {currentItems.map((item, id)=>(
                                    <>
                                        <div className="col-xl-12" key={id}>
                                            <div className="services__page-item media-rating-container">
                                                <div className="services__page-item-left">
                                                    <p style={{marginRight: '20px'}}>{id + 1}</p>
                                                    <div className="services__page-item-left-icon">
                                                        <img src={item.imageLink == '' ? '/images/cup.svg' : item.imageLink == 'none' ? '/images/cup.svg' : item.imageLink} alt="" />
                                                    <div className="services__area-item-icon-one">
                                                        <img src={item.teamLogo == '' ? '/images/cup.svg' : item.teamLogo == 'none' ? '/images/cup.svg' : item.teamLogo} alt="" />
                                                    </div>
                                                    </div>
                                                    <div className="services__page-item-left-content">
                                                        <h4><p>{item.playerName}</p></h4>
                                                    </div>
                                                </div>
                                                <div className='pr-card-box'>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Kills - {item.kills}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.kills / firstValues.kills) * 100 < 25 ? "red" : (item.kills / firstValues.kills) * 100 < 75 ? '#ffc800' : (item.kills / firstValues.kills) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.kills / firstValues.kills) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>K/D - {(item.kd / item.kdLen).toFixed(2)}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: ((item.kd / item.kdLen) / firstValues.kd) * 100 < 25 ? "red" : ((item.kd / item.kdLen) / firstValues.kd) * 100 < 75 ? '#ffc800' : ((item.kd / item.kdLen) / firstValues.kd) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${((item.kd / item.kdLen) / firstValues.kd) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Tournaments - {item.tournament.length}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.tournament.length / firstValues.tournaments) * 100 < 25 ? "red" : (item.tournament.length / firstValues.tournaments) * 100 < 75 ? '#ffc800' : (item.tournament.length / firstValues.tournaments) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.tournament.length / firstValues.tournaments) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="services__page-item-right">
                                                    <p onClick={() => {document.getElementById(`card${id + 1}`).classList.toggle('media-rating-container-active'); document.getElementById(`minus${id + 1}`).classList.toggle('fa-minus'); document.getElementById(`minus${id + 1}`).classList.toggle('fa-plus')}}><i id={`minus${id + 1}`} className="fal fa-plus"></i></p>
                                                </div>
                                            </div>
                                            <div id={`card${id + 1}`} style={{marginTop: '0'}} className="media-rating-container-toggle media-rating-container">
                                                <span style={{width: '100%'}} className="pr-all-card">
                                                    <div className="pr-all-card-stat">
                                                        <div className="pr-all-card-stat-div">
                                                            <p>{item.firstName} <strong>"{item.name}"</strong> {item.lastName} - <img style={{height: '25px'}} className="pr-flag" src={`https://flagsapi.com/${item.flag}/flat/64.png`} alt="" /></p>
                                                            <p style={{display: 'flex', alignItems: 'center', borderBottom: '1px solid #9FA0A1', marginBottom: '10px', paddingBottom: '10px'}}>{item.teamName} - <img style={{height: '25px'}} src={item.teamLogo == '' ? '/images/cup.svg' : item.teamLogo == 'none' ? '/images/cup.svg' : item.teamLogo} alt="" /></p>
                                                        </div>
                                                    </div>
                                                    <div className="pr-all-card-tour">
                                                    <ul style={{display: 'flex', justifyContent: 'space-between', width: '100%', padding: '0'}}>
                                                            <p style={{width: "40%", textAlign: 'start'}}>TOURS</p>
                                                            <p className='prize-rating' style={{width: "20%", textAlign: 'center'}}>PRIZE</p>
                                                            <p style={{width: "20%", textAlign: 'center'}}>KILLS</p>
                                                            <p style={{width: "20%", textAlign: 'center'}}>K/D</p>
                                                        </ul>
                                                        <ol style={{padding: '0'}}>
                                                        {
                                                            item.tournament.map((data, i) => (
                                                                <li style={{display: 'flex', justifyContent: 'space-between', width: '100%', borderBottom: '1px solid rgb(113 113 113)', marginBottom: '8px'}} key={i}>
                                                                    <p style={{width: "40%", textAlign: 'start'}}>{data.tourName}({data.teamPlace})</p>
                                                                    <p className='prize-rating' style={{width: "20%", textAlign: 'center'}}>{data.prize ? `${data.prize} usd.` : data.teamPrize ? `${data.teamPrize} usd.` : ''}</p>
                                                                    <p style={{width: "20%", textAlign: 'center'}}>{data.kills}</p>
                                                                    <p style={{width: "20%", textAlign: 'center', color: data.kd < 1 ? 'red' : 'rgb(3 253 69)'}}>{data.kd.toFixed(2)}</p>
                                                                </li>
                                                            ))
                                                        }
                                                        </ol>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                <FooterOne></FooterOne>        
            </> : <Preloader />
        }
    </>;
};

export default FemalePage;